import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const Receipts = lazyWithRetry(() => import('./Receipts'));

const ReceiptRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="receipts">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Receipts />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default ReceiptRoutes;
